
// state
export const state = {
  shadowPopup: false
}

// mutations
export const mutations = {
  SET_SHADOW_POPUP (state, payload) {
    state.shadowPopup = payload
  }
}

// actions
export const actions = {
  async setShadowPopup ({ commit }, payload) {
    try {
      commit('SET_SHADOW_POPUP', payload)
    } catch (e) {
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/calculation.js